import { Link } from 'react-router-dom';

const Section = ({ id, num, title, children }) => (
  <section id={id} className="mb-5">
    <h4 className="fw-bold mb-3 d-flex align-items-center gap-2" style={{ color: '#1a1a2e' }}>
      <span
        className="d-inline-flex align-items-center justify-content-center rounded-circle text-white fw-bold flex-shrink-0"
        style={{ width: 32, height: 32, fontSize: 13, background: '#ff6600' }}
      >
        {num}
      </span>
      {title}
    </h4>
    <div className="ps-2" style={{ borderLeft: '3px solid #ff660022' }}>
      {children}
    </div>
  </section>
);

const Art = ({ children }) => (
  <p className="text-muted mb-3" style={{ fontSize: 14, lineHeight: 1.9 }}>
    {children}
  </p>
);

const TABLE_OF_CONTENTS = [
  { id: 'objet', num: 1, label: "Objet et champ d'application" },
  { id: 'definitions', num: 2, label: 'Définitions' },
  { id: 'inscription', num: 3, label: 'Inscription et compte utilisateur' },
  { id: 'service', num: 4, label: 'Description du service' },
  { id: 'annonces', num: 5, label: 'Publication et gestion des annonces' },
  { id: 'reservation', num: 6, label: 'Processus de réservation' },
  { id: 'prix', num: 7, label: 'Prix, commissions et paiement' },
  { id: 'annulation', num: 8, label: 'Annulation et remboursement' },
  { id: 'garantie', num: 9, label: 'Dépôt de garantie' },
  { id: 'assurance', num: 10, label: 'Assurance et responsabilité' },
  { id: 'rgpd', num: 11, label: 'Protection des données (RGPD)' },
  { id: 'droits', num: 12, label: 'Droits des consommateurs (UE)' },
  { id: 'litiges', num: 13, label: 'Litiges et médiation' },
  { id: 'droit', num: 14, label: 'Droit applicable' },
  { id: 'modification', num: 15, label: 'Modification des CGU' },
];

export default function ConditionsGenerales() {
  return (
    <div className="bg-body-tertiary min-vh-100">
      {/* Hero */}
      <div
        className="py-5 text-white"
        style={{
          background: 'linear-gradient(135deg, #1a1a2e 0%, #2d2d4e 100%)',
        }}
      >
        <div className="container">
          <span
            className="badge bg-white text-dark rounded-pill px-3 py-2 mb-3"
            style={{ fontSize: 12 }}
          >
            <i className="bi bi-globe-europe-africa me-1"></i>Applicable Union Européenne
          </span>
          <h1 className="fw-bold mb-2">Conditions Générales d'Utilisation</h1>
          <p className="mb-1 opacity-75" style={{ fontSize: 14 }}>
            Moovicar SAS — Version en vigueur au <strong>1ᵉʳ janvier 2025</strong>
          </p>
          <p className="opacity-60 mb-0" style={{ fontSize: 12 }}>
            Conformes au Règlement (UE) 2016/679 (RGPD) · Directive 2011/83/UE (droits des
            consommateurs) · Directive 2000/31/CE (commerce électronique)
          </p>
        </div>
      </div>

      <div className="container py-5" style={{ maxWidth: 860 }}>
        <div className="row g-4">
          {/* Sommaire sticky */}
          <div className="col-12 col-lg-3 d-none d-lg-block">
            <div className="card border-0 shadow-sm rounded-4 p-3 sticky-top" style={{ top: 80 }}>
              <p
                className="fw-semibold mb-3 small text-uppercase text-muted"
                style={{ letterSpacing: '0.06em', fontSize: 11 }}
              >
                Sommaire
              </p>
              <ul className="list-unstyled mb-0">
                {TABLE_OF_CONTENTS.map(({ id, num, label }) => (
                  <li key={id} className="mb-1">
                    <a
                      href={`#${id}`}
                      className="text-decoration-none text-muted d-flex align-items-start gap-2"
                      style={{ fontSize: 12, lineHeight: 1.5 }}
                    >
                      <span className="fw-bold text-primary flex-shrink-0" style={{ fontSize: 11 }}>
                        {num}.
                      </span>
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Contenu */}
          <div className="col-12 col-lg-9">
            <div className="card border-0 shadow-sm rounded-4 p-4 p-md-5">
              {/* Préambule */}
              <div className="alert alert-warning d-flex gap-3 mb-5" style={{ fontSize: 13 }}>
                <i className="bi bi-info-circle-fill flex-shrink-0 mt-1 text-warning"></i>
                <div>
                  En accédant à la plateforme Moovicar et en utilisant ses services, vous
                  reconnaissez avoir lu, compris et accepté sans réserve les présentes Conditions
                  Générales d'Utilisation (CGU). Si vous n'acceptez pas ces conditions, vous devez
                  cesser immédiatement d'utiliser le service.
                </div>
              </div>

              {/* 1 — Objet */}
              <Section id="objet" num={1} title="Objet et champ d'application">
                <Art>
                  Les présentes Conditions Générales d'Utilisation ont pour objet de définir les
                  modalités et conditions d'utilisation des services proposés par{' '}
                  <strong>Moovicar SAS</strong>, société par actions simplifiée, sur la plateforme
                  accessible à l'adresse
                  <strong> app.moovicar.com</strong> et via l'application mobile Moovicar.
                </Art>
                <Art>
                  Moovicar opère en qualité d'
                  <strong>intermédiaire de mise en relation</strong> entre des particuliers
                  souhaitant louer leur véhicule (« Hôtes ») et des particuliers souhaitant louer un
                  véhicule (« Conducteurs »). Moovicar n'est pas partie au contrat de location
                  conclu entre les utilisateurs.
                </Art>
                <Art>
                  Les présentes CGU sont applicables à l'ensemble des utilisateurs résidant dans un
                  État membre de l'Union Européenne, conformément aux réglementations en vigueur,
                  notamment la Directive 2011/83/UE relative aux droits des consommateurs et le
                  Règlement (UE) 2016/679 (RGPD).
                </Art>
              </Section>

              {/* 2 — Définitions */}
              <Section id="definitions" num={2} title="Définitions">
                <div className="table-responsive">
                  <table className="table table-bordered align-top" style={{ fontSize: 13 }}>
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: '30%' }}>Terme</th>
                        <th>Définition</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        [
                          'Plateforme',
                          "Le site web app.moovicar.com et l'application mobile Moovicar.",
                        ],
                        [
                          'Hôte / Propriétaire',
                          'Utilisateur mettant son véhicule en location via la Plateforme.',
                        ],
                        [
                          'Conducteur / Invité',
                          'Utilisateur louant un véhicule via la Plateforme.',
                        ],
                        ['Annonce', 'Offre de location publiée par un Hôte sur la Plateforme.'],
                        [
                          'Réservation',
                          "Contrat de location conclu entre l'Hôte et le Conducteur via la Plateforme.",
                        ],
                        [
                          'Commission',
                          'Frais de service prélevés par Moovicar sur chaque transaction.',
                        ],
                        ['Check-in', 'État des lieux de départ validé avant remise du véhicule.'],
                        [
                          'Checkout',
                          'État des lieux de retour validé lors de la restitution du véhicule.',
                        ],
                        [
                          'Dépôt de garantie',
                          "Pré-autorisation bancaire destinée à couvrir d'éventuels dommages.",
                        ],
                      ].map(([t, d]) => (
                        <tr key={t}>
                          <td className="fw-semibold">{t}</td>
                          <td className="text-muted">{d}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </Section>

              {/* 3 — Inscription */}
              <Section id="inscription" num={3} title="Inscription et compte utilisateur">
                <Art>
                  L'inscription sur la Plateforme est <strong>gratuite</strong> et ouverte à toute
                  personne physique majeure (18 ans minimum) résidant dans un pays couvert par le
                  service. L'utilisateur doit fournir des informations exactes, complètes et à jour
                  lors de son inscription.
                </Art>
                <Art>Pour louer un véhicule, le Conducteur doit obligatoirement :</Art>
                <ul className="text-muted mb-3" style={{ fontSize: 14 }}>
                  <li className="mb-1">
                    Fournir un permis de conduire valide, numérisé et vérifié sur la Plateforme ;
                  </li>
                  <li className="mb-1">
                    Fournir une pièce d'identité (carte nationale d'identité ou passeport en cours
                    de validité) ;
                  </li>
                  <li className="mb-1">
                    Enregistrer un moyen de paiement valide (carte bancaire).
                  </li>
                </ul>
                <Art>
                  Chaque utilisateur ne peut détenir qu'un seul compte. Tout compte créé avec de
                  fausses informations pourra être suspendu sans préavis. L'utilisateur est seul
                  responsable de la confidentialité de ses identifiants.
                </Art>
              </Section>

              {/* 4 — Service */}
              <Section id="service" num={4} title="Description du service">
                <Art>
                  Moovicar fournit une <strong>plateforme d'intermédiation numérique</strong>{' '}
                  permettant la mise en relation entre Hôtes et Conducteurs. La Plateforme propose
                  notamment :
                </Art>
                <ul className="text-muted mb-3" style={{ fontSize: 14 }}>
                  <li className="mb-1">Un moteur de recherche et de réservation de véhicules ;</li>
                  <li className="mb-1">Un système de messagerie sécurisée entre utilisateurs ;</li>
                  <li className="mb-1">
                    Un module de gestion d'état des lieux (check-in / checkout) ;
                  </li>
                  <li className="mb-1">Un système de paiement en ligne via Stripe ;</li>
                  <li className="mb-1">Un service de notation et d'avis post-location ;</li>
                  <li className="mb-1">
                    Un accès à la couverture d'assurance AXA pendant la location.
                  </li>
                </ul>
                <Art>
                  Moovicar se réserve le droit de modifier, suspendre ou interrompre tout ou partie
                  du service, à tout moment et sans préavis, notamment pour des raisons de
                  maintenance ou d'amélioration.
                </Art>
              </Section>

              {/* 5 — Annonces */}
              <Section id="annonces" num={5} title="Publication et gestion des annonces">
                <Art>
                  L'Hôte s'engage à fournir des informations <strong>exactes et à jour</strong>{' '}
                  concernant son véhicule : état réel, kilométrage, équipements, disponibilités et
                  photos représentatives. Toute annonce trompeuse pourra entraîner la suspension du
                  compte.
                </Art>
                <Art>
                  Les documents suivants sont <strong>obligatoires</strong> pour qu'une annonce soit
                  validée et publiée :
                </Art>
                <ul className="text-muted mb-3" style={{ fontSize: 14 }}>
                  <li className="mb-1">Certificat d'immatriculation (carte grise) ;</li>
                  <li className="mb-1">Attestation d'assurance valide ;</li>
                  <li className="mb-1">
                    Contrôle technique en cours de validité (véhicule de plus de 4 ans).
                  </li>
                </ul>
                <Art>
                  Moovicar se réserve le droit de refuser ou de retirer toute annonce ne respectant
                  pas les présentes conditions, sans qu'aucune indemnité ne soit due à l'Hôte.
                </Art>
              </Section>

              {/* 6 — Réservation */}
              <Section id="reservation" num={6} title="Processus de réservation">
                <Art>Le processus de réservation se déroule en plusieurs étapes :</Art>
                <ol className="text-muted mb-3" style={{ fontSize: 14 }}>
                  <li className="mb-2">
                    <strong>Demande</strong> — Le Conducteur envoie une demande de réservation à
                    l'Hôte (statut : <code>pending</code>) ;
                  </li>
                  <li className="mb-2">
                    <strong>Acceptation</strong> — L'Hôte dispose de 48 h pour accepter ou refuser
                    la demande (statut : <code>accepted</code> ou <code>rejected</code>) ;
                  </li>
                  <li className="mb-2">
                    <strong>Paiement</strong> — En cas d'acceptation, le Conducteur procède au
                    paiement via Stripe (statut : <code>paid</code>) ;
                  </li>
                  <li className="mb-2">
                    <strong>Check-in</strong> — Réalisation et validation de l'état des lieux de
                    départ (statut : <code>in_progress</code>) ;
                  </li>
                  <li className="mb-2">
                    <strong>Checkout</strong> — Retour du véhicule et validation de l'état des lieux
                    de retour (statut : <code>completed</code>).
                  </li>
                </ol>
                <Art>
                  La réservation est <strong>ferme et définitive</strong> dès la capture du
                  paiement. Pour consulter le détail de chaque statut, rendez-vous sur la page{' '}
                  <Link to="/etats-reservation">États de réservation</Link>.
                </Art>
              </Section>

              {/* 7 — Prix */}
              <Section id="prix" num={7} title="Prix, commissions et paiement">
                <Art>
                  Tous les prix affichés sur la Plateforme sont exprimés en{' '}
                  <strong>euros (€) TTC</strong>. Moovicar prélève une commission sur chaque
                  transaction selon le barème suivant :
                </Art>
                <div className="table-responsive mb-3">
                  <table
                    className="table table-sm table-bordered align-middle"
                    style={{ fontSize: 13 }}
                  >
                    <thead className="table-light">
                      <tr>
                        <th>Partie</th>
                        <th>Commission</th>
                        <th>Base de calcul</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Hôte (propriétaire)</td>
                        <td className="fw-semibold text-primary">15 %</td>
                        <td>Prix de location HT</td>
                      </tr>
                      <tr>
                        <td>Conducteur (invité)</td>
                        <td className="fw-semibold text-primary">10 %</td>
                        <td>Prix de location HT</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <Art>
                  Les paiements sont traités par <strong>Stripe, Inc.</strong> (prestataire de
                  services de paiement agréé), conformément aux conditions générales de Stripe
                  disponibles sur stripe.com. Moovicar ne stocke aucune donnée bancaire sur ses
                  serveurs.
                </Art>
                <Art>
                  Conformément à la <strong>Directive (UE) 2015/2366 (DSP2)</strong>, les paiements
                  peuvent nécessiter une authentification forte (3D Secure).
                </Art>
              </Section>

              {/* 8 — Annulation */}
              <Section id="annulation" num={8} title="Annulation et remboursement">
                <Art>
                  Conformément à l'article L.221-28 du Code de la consommation, le{' '}
                  <strong>droit de rétractation de 14 jours</strong> ne s'applique pas aux services
                  de location dont l'exécution est prévue à une date déterminée.
                </Art>
                <Art>La politique d'annulation de Moovicar est la suivante :</Art>
                <div className="table-responsive mb-3">
                  <table
                    className="table table-sm table-bordered align-middle"
                    style={{ fontSize: 13 }}
                  >
                    <thead className="table-light">
                      <tr>
                        <th>Délai avant le début</th>
                        <th>Remboursement Conducteur</th>
                        <th>Versement Hôte</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{'>'} 7 jours</td>
                        <td className="text-success fw-semibold">100 %</td>
                        <td>0 %</td>
                      </tr>
                      <tr>
                        <td>48 h – 7 jours</td>
                        <td className="text-warning fw-semibold">50 %</td>
                        <td>50 % (−commission)</td>
                      </tr>
                      <tr>
                        <td>{'<'} 48 h</td>
                        <td className="text-danger fw-semibold">0 %</td>
                        <td>75 % (−commission)</td>
                      </tr>
                      <tr>
                        <td>Annulation par l'Hôte</td>
                        <td className="text-success fw-semibold">100 % + 25 € d'indemnité</td>
                        <td>Pénalité appliquée</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <Art>
                  Les frais de service (commission Conducteur) ne sont{' '}
                  <strong>jamais remboursés</strong>. Les remboursements sont traités sous 5 à 10
                  jours ouvrés selon l'établissement bancaire.
                </Art>
              </Section>

              {/* 9 — Garantie */}
              <Section id="garantie" num={9} title="Dépôt de garantie">
                <Art>
                  Un dépôt de garantie fait l'objet d'une <strong>pré-autorisation bancaire</strong>
                  (sans débit réel) au moment de la confirmation de paiement. Son montant varie de
                  300 € (catégorie Éco) à 2 500 € (catégorie Prestige).
                </Art>
                <Art>
                  La pré-autorisation est libérée <strong>dans un délai de 72 heures</strong>{' '}
                  suivant la validation du checkout sans incident. En cas de dommages constatés,
                  Moovicar peut capturer tout ou partie du dépôt, dans la limite du montant de la
                  franchise, après instruction du dossier. L'utilisateur en sera informé par email.
                </Art>
              </Section>

              {/* 10 — Assurance */}
              <Section id="assurance" num={10} title="Assurance et responsabilité">
                <Art>
                  Tous les trajets réalisés via Moovicar sont couverts par une assurance souscrite
                  auprès d'<strong>AXA</strong>, active de la validation du check-in à la validation
                  du checkout. La couverture inclut la responsabilité civile et les dommages
                  matériels selon les conditions de la police d'assurance AXA.
                </Art>
                <Art>
                  Moovicar, en tant qu'intermédiaire, <strong>n'est pas responsable</strong> des
                  dommages causés au véhicule, des accidents de la circulation, des infractions au
                  Code de la route commises par le Conducteur, ni de tout préjudice indirect
                  résultant de l'utilisation du service.
                </Art>
                <Art>
                  La responsabilité de Moovicar est en tout état de cause limitée au montant des
                  commissions perçues sur la transaction concernée.
                </Art>
              </Section>

              {/* 11 — RGPD */}
              <Section id="rgpd" num={11} title="Protection des données personnelles (RGPD)">
                <Art>
                  Conformément au <strong>Règlement (UE) 2016/679 du 27 avril 2016 (RGPD)</strong>,
                  Moovicar SAS agit en qualité de <strong>responsable du traitement</strong> des
                  données personnelles collectées sur la Plateforme.
                </Art>
                <Art>
                  Les données collectées (nom, prénom, email, permis de conduire, pièce d'identité,
                  données bancaires via Stripe, géolocalisation) sont utilisées aux fins suivantes :
                </Art>
                <ul className="text-muted mb-3" style={{ fontSize: 14 }}>
                  <li className="mb-1">Gestion des comptes et vérification d'identité ;</li>
                  <li className="mb-1">Traitement et suivi des réservations ;</li>
                  <li className="mb-1">Traitement des paiements via Stripe ;</li>
                  <li className="mb-1">
                    Lutte contre la fraude et respect des obligations légales ;
                  </li>
                  <li className="mb-1">
                    Amélioration du service et communications transactionnelles.
                  </li>
                </ul>
                <Art>
                  Conformément au RGPD, vous disposez des droits suivants :{' '}
                  <strong>
                    accès, rectification, effacement, limitation, portabilité et opposition
                  </strong>
                  . Pour exercer ces droits, contactez notre DPO à :{' '}
                  <strong>dpo@moovicar.com</strong>. Vous pouvez également introduire une
                  réclamation auprès de la CNIL (France) ou de l'autorité de contrôle compétente de
                  votre État membre.
                </Art>
                <Art>
                  Les données sont conservées pendant <strong>5 ans</strong> à compter de la
                  dernière activité du compte, conformément aux obligations légales en matière
                  fiscale et comptable.
                </Art>
              </Section>

              {/* 12 — Droits UE */}
              <Section id="droits" num={12} title="Droits des consommateurs (Union Européenne)">
                <Art>
                  Conformément à la <strong>Directive 2011/83/UE</strong> transposée en droit
                  national, Moovicar s'engage à fournir aux consommateurs européens une information
                  précontractuelle claire et complète avant toute transaction.
                </Art>
                <Art>
                  Conformément au <strong>Règlement (UE) 2022/2065</strong> (Digital Services Act —
                  DSA), Moovicar met en œuvre des mécanismes de signalement des contenus illicites
                  et de transparence sur les recommandations algorithmiques.
                </Art>
                <Art>
                  Les utilisateurs résidant dans l'Union Européenne bénéficient des garanties
                  supplémentaires prévues par :
                </Art>
                <ul className="text-muted mb-3" style={{ fontSize: 14 }}>
                  <li className="mb-1">
                    <strong>Directive 2019/770/UE</strong> — fourniture de contenus et services
                    numériques ;
                  </li>
                  <li className="mb-1">
                    <strong>Règlement (UE) 2019/1150</strong> — relations plateformes-entreprises
                    (P2B) ;
                  </li>
                  <li className="mb-1">
                    <strong>Directive 2015/2366/UE (DSP2)</strong> — services de paiement sécurisés.
                  </li>
                </ul>
              </Section>

              {/* 13 — Litiges */}
              <Section id="litiges" num={13} title="Litiges et médiation">
                <Art>
                  En cas de litige entre utilisateurs, Moovicar met à disposition un système de
                  signalement accessible depuis la messagerie. L'équipe Moovicar dispose de
                  <strong> 15 jours ouvrés</strong> pour instruire le dossier et rendre une
                  décision.
                </Art>
                <Art>
                  Conformément à l'<strong>Ordonnance n° 2015-1033</strong> et à la
                  <strong> Directive 2013/11/UE</strong> relative au règlement extrajudiciaire des
                  litiges de consommation, tout consommateur peut recourir gratuitement à un
                  médiateur de la consommation. Moovicar adhère au service de médiation :
                </Art>
                <div
                  className="rounded-3 border p-3 mb-3 bg-body-tertiary"
                  style={{ fontSize: 13 }}
                >
                  <strong>Médiateur de la consommation agréé :</strong>
                  <br />
                  Centre de Médiation et d'Arbitrage de Paris (CMAP)
                  <br />
                  39 avenue Franklin D. Roosevelt — 75008 Paris
                  <br />
                  <a href="https://www.cmap.fr" target="_blank" rel="noreferrer">
                    www.cmap.fr
                  </a>
                  {' · '}
                  <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noreferrer">
                    Plateforme ODR européenne
                  </a>
                </div>
              </Section>

              {/* 14 — Droit applicable */}
              <Section id="droit" num={14} title="Droit applicable">
                <Art>
                  Les présentes CGU sont régies par le <strong>droit français</strong>. En cas de
                  litige non résolu par la médiation, les tribunaux compétents seront ceux du
                  ressort du siège social de Moovicar SAS, sauf disposition contraire d'ordre public
                  applicable dans le pays de résidence du consommateur européen.
                </Art>
                <Art>
                  Pour les utilisateurs résidant dans un autre État membre de l'UE, les dispositions
                  impératives de protection des consommateurs du pays de résidence s'appliquent
                  conformément au <strong>Règlement Rome I (CE 593/2008)</strong>.
                </Art>
              </Section>

              {/* 15 — Modification */}
              <Section id="modification" num={15} title="Modification des CGU">
                <Art>
                  Moovicar se réserve le droit de modifier les présentes CGU à tout moment. Les
                  utilisateurs seront informés de toute modification substantielle par
                  <strong> email</strong> et par notification sur la Plateforme, au moins
                  <strong> 30 jours</strong> avant l'entrée en vigueur des nouvelles conditions.
                </Art>
                <Art>
                  La poursuite de l'utilisation de la Plateforme après l'entrée en vigueur des
                  modifications vaudra acceptation des nouvelles CGU. En cas de désaccord,
                  l'utilisateur a la faculté de résilier son compte sans frais.
                </Art>
              </Section>

              {/* Footer légal */}
              <div
                className="rounded-3 p-4 text-center"
                style={{ background: '#f8f9fa', fontSize: 13, color: '#666' }}
              >
                <p className="mb-1">
                  <strong>Moovicar SAS</strong> — Société par actions simplifiée
                </p>
                <p className="mb-1">
                  Siège social : Paris, France · SIRET : en cours d'enregistrement
                </p>
                <p className="mb-3">
                  Contact légal :{' '}
                  <a href="mailto:legal@moovicar.com" className="text-primary">
                    legal@moovicar.com
                  </a>
                  {' · '}DPO :{' '}
                  <a href="mailto:dpo@moovicar.com" className="text-primary">
                    dpo@moovicar.com
                  </a>
                </p>
                <div className="d-flex flex-wrap justify-content-center gap-2">
                  <Link to="/privacy" className="btn btn-outline-secondary btn-sm rounded-pill">
                    Politique de confidentialité
                  </Link>
                  <Link to="/cookies" className="btn btn-outline-secondary btn-sm rounded-pill">
                    Cookies
                  </Link>
                  <Link to="/help" className="btn btn-outline-secondary btn-sm rounded-pill">
                    Centre d'aide
                  </Link>
                  <Link
                    to="/regles-business"
                    className="btn btn-outline-secondary btn-sm rounded-pill"
                  >
                    Règles business
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
